// extracted by mini-css-extract-plugin
module.exports = {"base":"styles_base__B54I1","backgroundImage":"styles_backgroundImage__2Qd6K","container":"styles_container__9Prie","logo":"styles_logo__Xgad6"};